module.exports = __webpack_public_path__ + "static/media/shield-virus-bug-svgrepo-com.8aa346b3.svg";